"use client";

// Renders a form builder form and sends it (docs: documents/hooks/useFormRenderer.md). The code lives in ../form-renderer.
export { default } from "@core/helpers/client/form-renderer/use_form_renderer";
